import { DrawerList } from '@pages/QuoteDetails/constants/DrawerList.enum';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type LayoutStore = {
  showHeaderMenu: boolean;
  openHeaderMenu: () => void;
  closeHeaderMenu: () => void;
  secondaryMenuTab: DrawerList | null;
  setSecondaryMenuTab: (tab: DrawerList) => void;
  highlightedNavigationElement: string | null;
  setHighlightedNavigationElementId: (elementId: string | null) => void;
  setCustomHeaderRenderedInLayout: (Component?: any) => void;
  customHeaderRenderedInLayout?: boolean;
  sidebarWidth: number[];
  setSidebarWidth: (sidebarWidth: number[]) => void;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
};

export const initialState = {
  showHeaderMenu: false,
  secondaryMenuTab: null,
  highlightedNavigationElement: null,
  sidebarWidth: [300],
  isSidebarOpen: false,
};

export const useLayoutStore = createWithEqualityFn<LayoutStore>()(
  (set) => ({
    ...initialState,
    openHeaderMenu: () =>
      set(() => ({
        showHeaderMenu: true,
      })),
    closeHeaderMenu: () =>
      set(() => ({
        showHeaderMenu: false,
      })),
    setSecondaryMenuTab: (tab) =>
      set((state) => ({
        ...state,
        secondaryMenuTab: tab,
      })),
    setCustomHeaderRenderedInLayout: (value) =>
      set((state) => ({
        ...state,
        customHeaderRenderedInLayout: value,
      })),
    setHighlightedNavigationElementId: (elementId: string | null) =>
      set((state) => ({
        ...state,
        highlightedNavigationElement: elementId,
      })),
    setSidebarWidth: (sidebarWidths) =>
      set((state) => {
        return {
          ...state,
          sidebarWidth: sidebarWidths?.filter((width) => !!width),
        };
      }),
    setIsSidebarOpen: (isSidebarOpen) =>
      set((state) => ({
        ...state,
        isSidebarOpen,
      })),
  }),
  shallow,
);
